import React, { useState } from "react";
import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import {
  Button,
  ButtonGroup,
  Input,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import downloadIcon from "../../../../assets/icon/download-purple.svg";
import printerIcon from "../../../../assets/icon/printer.svg";
import doubleArrow from "../../../../assets/icon/double-arrow-down-purple.svg";
import refreshIcon from "../../../../assets/icon/reload-icon.svg";
import refreshPurpleIcon from "../../../../assets/icon/refresh-purple.svg";
import downloadWhiteIcon from "../../../../assets/icon/download-white.svg";
import editIocn from "../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../assets/inventory/delete-icon.svg";
import AddMedicalCondition from "./AddMedicalCondition";
import CloseIcon from "assets/icon/chatClose.svg";
import addIcon from "../../../../assets/inventory/add-btn-clinic.svg";
// import refreshIcon  from "../../../../../../assets/icon/refresh-white.svg";
import refreshWhiteIcon from "../../../../assets/icon/refresh-white.svg";
import plusIcon from "../../../../assets/icon/plus-icon.svg";
import printDisableIcon from "../../../../assets/inventory/print-disable.svg";
import downloadDisableIcon from "../../../../assets/inventory/download-disable.svg";
import plusDisableIcon from "../../../../assets/inventory/plus-disable.svg";
import saveDisableIcon from "../../../../assets/icon/save-btn-icon-white.svg";
import saveWhiteIcon from "../../../../assets/icon/save-white-icon.svg";
import plusRoundIcon from "../../../../assets/inventory/plus-rounded.svg";
import AddAllergies from "./AddAllergies";
import AddLabvalues from "./AddLabvalues";
import ImmunizationDetails from "./ImmunizationDetails";

const Clinical = () => {
  const [showDetails, setShowDetails] = useState("allergies");
  const [show, setShow] = useState(false);
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [rSelected, setRSelected] = useState("off");
  const [tableData, setTableData] = useState(rowData);
  const [data, setData] = useState([]);
  const [editDetails, setEditDetails] = useState(false);
  const [immunizationDetails, setImmunizationDetails] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [medicalSelectedRows, setMedicalSelectedRows] = useState([]);
  const [immunizationSelectedRows, setImmunizationSelectedRows] = useState([]);
  const [labvaluesSelectedRows, setLabValuesSelectedRows] = useState([]);
  const [reactionDate, setReactiondate] = useState("");
  const [reportedDate, setReportedDate] = useState("");
  const [diagnosedDate, setDiagnosedDate] = useState("");
  const [medicalCondition, setMedicalCondition] = useState({
    diagnosed: "",
    icd: "",
    conditions: "",
    allergy: "",
  });

  const [addAllergy, setAddAllergy] = useState({
    allergyName: "",
    typeofReaction: "",
    notes: "",
  });

  const [labValues, setLabValues] = useState({
    source: "",
    values: "",
    notes: "",
    description: "",
  });

  const rowData = [
    {
      id: 1,
      allergy: "Penicillin",
      reaction: "Anaphylaxis",
      date: "1/18/2008",
      timerange: "4/17/2025",
      notes: "Sourced from E-Rx",
    },
    {
      id: 2,
      allergy: "Sulfa",
      reaction: "Rash",
      date: "Unknown",
      timerange: "4/17/2025",
      notes: "",
    },
  ];

  const [addNewAllergy, setAddNewAllergy] = useState(rowData);

  const MedicalConditionRowData = [
    {
      id: 1,
      options: (
        <div>
          <img
            src={editIocn}
            className="cursor-pointer"
            onClick={() => setEditDetails(!editDetails)}
          />{" "}
          <img src={deleteIcon} />
        </div>
      ),
      status: "Active",
      condition: "Hypertension",
      icd: "I10.59",
      provider: "Jones, Jack",
      datediagnosed: "5/21/2025",
    },
    {
      id: 2,
      options: (
        <div>
          <img
            src={editIocn}
            className="cursor-pointer"
            onClick={() => setEditDetails(!editDetails)}
          />{" "}
          <img src={deleteIcon} />
        </div>
      ),
      status: "Resolved",
      condition: "Pneumonia, Unspecified",
      icd: "J18.9",
      provider: "Jones, Jack",
      datediagnosed: "2/14/2025",
    },
  ];

  const ImmunizationRowData = [
    {
      id: 1,
      vaccinename: "Flucelvax 2024-2025 PF 0.5ml",
      administrationdate: "9/25/2024",
      dosenumber: "1",
      admpharmacylocation: "Store #055",
    },
    {
      id: 2,
      vaccinename: "Afluria 2023-2024 PF 0.5ml",
      administrationdate: "10/18/2023",
      dosenumber: "1",
      admpharmacylocation: "Store #055",
    },
  ];

  const LabValuesRowData = [
    {
      id: 1,
      options: (
        <div>
          <img
            src={editIocn}
            className="cursor-pointer"
            onClick={() => setEditDetails(!editDetails)}
          />{" "}
          <img src={deleteIcon} />
        </div>
      ),
      description: "BP",
      value: "190/90",
      notes: "N/A",
      recorddate: "5/21/2025",
      source: "Pharmacy",
    },
    {
      id: 2,
      options: (
        <div>
          <img
            src={editIocn}
            className="cursor-pointer"
            onClick={() => setEditDetails(!editDetails)}
          />{" "}
          <img src={deleteIcon} />
        </div>
      ),
      description: "K+",
      value: "5.9(H)",
      notes: "Abnormal",
      recorddate: "4/18/2025",
      source: "EHR",
    },
  ];

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(rowData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleMedicalSelectAll = (e) => {
    if (e.target.checked) {
      setMedicalSelectedRows(MedicalConditionRowData.map((row) => row.id));
    } else {
      setMedicalSelectedRows([]);
    }
  };

  const handleImmunizationSelectAll = (e) => {
    if (e.target.checked) {
      setImmunizationSelectedRows(ImmunizationRowData.map((row) => row.id));
    } else {
      setImmunizationSelectedRows([]);
    }
  };

  const handleLabvaluesSelectAll = (e) => {
    if (e.target.checked) {
      setLabValuesSelectedRows(LabValuesRowData.map((row) => row.id));
    } else {
      setLabValuesSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleMedicalSelectRow = (id) => {
    if (medicalSelectedRows.includes(id)) {
      setMedicalSelectedRows(
        medicalSelectedRows.filter((rowId) => rowId !== id)
      );
    } else {
      setMedicalSelectedRows([...medicalSelectedRows, id]);
    }
  };

  const handleImmunizationSelectRow = (id) => {
    if (immunizationSelectedRows.includes(id)) {
      setImmunizationSelectedRows(
        immunizationSelectedRows.filter((rowId) => rowId !== id)
      );
    } else {
      setImmunizationSelectedRows([...immunizationSelectedRows, id]);
    }
  };

  const handleLabvaluesSelectRow = (id) => {
    if (labvaluesSelectedRows.includes(id)) {
      setLabValuesSelectedRows(
        labvaluesSelectedRows.filter((rowId) => rowId !== id)
      );
    } else {
      setLabValuesSelectedRows([...labvaluesSelectedRows, id]);
    }
  };

  const RowCheckBox = (rowData) => {
    return (
      <div>
        {" "}
        <Input
          type="checkbox"
          onChange={() => handleSelectRow(rowData.id)}
          checked={selectedRows.includes(rowData.id)}
        />
      </div>
    );
  };

  const MedicalRowCheckBox = (rowData) => {
    return (
      <div>
        {" "}
        <Input
          type="checkbox"
          onChange={() => handleMedicalSelectRow(rowData.id)}
          checked={medicalSelectedRows.includes(rowData.id)}
        />
      </div>
    );
  };

  const ImmunizationRowCheckBox = (rowData) => {
    return (
      <div>
        {" "}
        <Input
          type="checkbox"
          onChange={() => handleImmunizationSelectRow(rowData.id)}
          checked={immunizationSelectedRows.includes(rowData.id)}
        />
      </div>
    );
  };

  const LabvaluesRowCheckBox = (rowData) => {
    return (
      <div>
        {" "}
        <Input
          type="checkbox"
          onChange={() => handleLabvaluesSelectRow(rowData.id)}
          checked={labvaluesSelectedRows.includes(rowData.id)}
        />
      </div>
    );
  };

  const handleDelete = (id) => {
    const del = addNewAllergy.filter((item) => item.id !== id);
    setAddNewAllergy(del);
  };

  const RowImgs = (res) => {
    return (
      <div>
        <img
          src={editIocn}
          className="cursor-pointer"
          onClick={() => setEditDetails(!editDetails)}
        />{" "}
        <img src={deleteIcon} onClick={() => handleDelete(res.id)} />
      </div>
    );
  };

  const ColumnData = [
    {
      dataField: "check",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Input
            type="checkbox"
            onChange={handleSelectAll}
            checked={selectedRows.length == rowData.length}
          />
          All
        </div>
      ),
      show: true,
      width: 50,
      cellRenderer: (rowData) => RowCheckBox(rowData),
    },
    {
      dataField: "options",
      text: "Option",
      sort: false,
      show: true,
      width: 60,
      cellRenderer: (rowData) => RowImgs(rowData),
    },
    {
      dataField: "allergy",
      text: "Allergy Name",
      sort: true,
      show: true,
    },
    {
      dataField: "reaction",
      text: "Type of Reaction",
      show: true,
      sort: true,
    },
    {
      dataField: "date",
      text: "Reaction Date",
      sort: true,
      show: true,
    },
    {
      dataField: "timerange",
      text: "Reported Date",
      sort: true,
      show: true,
    },
    {
      dataField: "notes",
      text: "Notes",
      sort: true,
      show: true,
    },
  ];

  const MedicalConditionColData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Input
            type="checkbox"
            onChange={handleMedicalSelectAll}
            checked={
              medicalSelectedRows.length == MedicalConditionRowData.length
            }
          />
          All
        </div>
      ),
      show: true,
      width: 50,
      cellRenderer: (rowData) => MedicalRowCheckBox(rowData),
    },
    {
      dataField: "options",
      text: "Option",
      show: true,
      sort: true,
      width: 60,
    },
    {
      dataField: "status",
      text: "Status",
      show: true,
      sort: true,
    },
    {
      dataField: "condition",
      text: "Condition",
      show: true,
      sort: true,
    },
    {
      dataField: "icd",
      text: "ICD-10",
      show: true,
      sort: true,
    },
    {
      dataField: "provider",
      text: "Provider",
      show: true,
      sort: true,
    },
    {
      dataField: "datediagnosed",
      text: "Date Diagnosed",
      show: true,
      sort: true,
    },
  ];

  const ImmunizationColData = [
    {
      dataField: "check",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Input
            type="checkbox"
            onChange={handleImmunizationSelectAll}
            checked={
              immunizationSelectedRows.length == ImmunizationRowData.length
            }
          />
          All
        </div>
      ),
      show: true,
      width: 50,
      cellRenderer: (rowData) => ImmunizationRowCheckBox(rowData),
    },
    {
      dataField: "vaccinename",
      text: "Vaccine Name",
      show: true,
      sort: true,
    },
    {
      dataField: "administrationdate",
      text: "Adminstation Date",
      show: true,
      sort: true,
    },
    {
      dataField: "dosenumber",
      text: "Dose Number",
      show: true,
      sort: true,
    },
    {
      dataField: "admpharmacylocation",
      text: "Administration Pharmacy Location",
      show: true,
      sort: true,
    },
  ];

  const LabValuesColData = [
    {
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Input
            type="checkbox"
            onChange={handleLabvaluesSelectAll}
            checked={labvaluesSelectedRows.length == LabValuesRowData.length}
          />
          All
        </div>
      ),
      show: true,
      width: 50,
      cellRenderer: (rowData) => LabvaluesRowCheckBox(rowData),
    },
    {
      dataField: "options",
      text: "Option",
      show: true,
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      show: true,
      sort: true,
    },
    {
      dataField: "value",
      text: "Value",
      show: true,
      sort: true,
    },
    {
      dataField: "notes",
      text: "Notes",
      show: true,
      sort: true,
    },
    {
      dataField: "recorddate",
      text: "Record Date",
      show: true,
      sort: true,
    },
    {
      dataField: "source",
      text: "Source",
      show: true,
      sort: true,
    },
  ];

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 2000);
  };

  const toggle = (id) => {
    setShowDetails((prevId) => (prevId === id ? null : id));
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <div>
            <SearchButtons
              InSize={250}
              placeHolder={"Search by Document Name"}
              data={data}
              setFilterData={setTableData}
            />
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {refreshBtn ? (
          <div className="refresh-bgv">
            <img className="rotate-img" src={refreshPurpleIcon} width={40} />
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <Button color="primary" onClick={handleRefresh}>
              <img src={refreshIcon} /> Refresh
            </Button>
          </div>
        )}
      </div>
      <div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="heading-text"
              style={{
                width: "100vw",
                height: "auto",
                justifyContent:
                  addNewAllergy.length == 0
                    ? "space-between"
                    : "" || showDetails == "allergies"
                    ? ""
                    : "space-between",
              }}
            >
              Allergies{" "}
              <span onClick={() => toggle("allergies")}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform:
                      showDetails == "allergies" ? "rotate(180deg)" : "",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
            {addNewAllergy.length !== 0 && (
              <>
                <div>
                  {showDetails == "allergies" ? (
                    <div className="d-flex justify-content-center align-items-center">
                      {selectedRows.length ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "white",
                              border: "none",
                            }}
                          >
                            <img src={printerIcon} />
                          </button>
                          <button
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              marginRight: "8px",
                            }}
                          >
                            <img src={downloadIcon} />
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            disabled
                            style={{
                              backgroundColor: "white",
                              border: "none",
                            }}
                          >
                            <img src={printDisableIcon} />
                          </button>
                          <button
                            disabled
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              marginRight: "8px",
                            }}
                          >
                            <img src={downloadDisableIcon} />
                          </button>
                        </>
                      )}
                      <span className="cursor-pointer">
                        <img src={addIcon} onClick={() => setShow(!show)} />
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
          </div>
          {showDetails == "allergies" && (
            <>
              {addNewAllergy.length == 0 ? (
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <div className="no-allergies">NO ALLERGIES ENTERED</div>
                  <div
                    className="add-allergy-btn"
                    onClick={() => setShow(!show)}
                  >
                    <img src={plusRoundIcon} style={{ marginRight: "8px" }} />
                    Add Allergies
                  </div>
                </div>
              ) : (
                <div className="table-card scroll-table position-relative rounded border-0  bg-white">
                  <ReactStrapTable
                    data={addNewAllergy}
                    columns={ColumnData}
                    hasPagination={false}
                  />
                </div>
              )}
            </>
          )}
        </div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="heading-text"
              style={{
                width: "100vw",
                height: "auto",
                justifyContent:
                  showDetails == "medical-condition" ? "" : "space-between",
              }}
            >
              <div>Medical Conditions </div>
              <div>
                <span onClick={() => toggle("medical-condition")}>
                  <img
                    className="cursor-pointer"
                    src={doubleArrow}
                    style={{
                      transform:
                        showDetails == "medical-condition"
                          ? "rotate(180deg)"
                          : "",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  />
                </span>
              </div>
            </div>
            {showDetails == "medical-condition" && (
              <div className="d-flex justify-content-center align-items-center">
                {medicalSelectedRows.length ? (
                  <>
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                      }}
                    >
                      <img src={printerIcon} />
                    </button>
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        marginRight: "8px",
                      }}
                    >
                      <img src={downloadIcon} />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      disabled
                      style={{
                        backgroundColor: "white",
                        border: "none",
                      }}
                    >
                      <img src={printDisableIcon} />
                    </button>
                    <button
                      disabled
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        marginRight: "8px",
                      }}
                    >
                      <img src={downloadDisableIcon} />
                    </button>
                  </>
                )}

                <span className="cursor-pointer">
                  <img src={addIcon} onClick={() => setShow(!show)} />
                </span>
              </div>
            )}
          </div>
          {showDetails == "medical-condition" ? (
            <div className="table-card scroll-table position-relative rounded border-0  bg-white">
              <ReactStrapTable
                data={MedicalConditionRowData}
                columns={MedicalConditionColData}
                hasPagination={false}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="heading-text"
              style={{
                width: "100vw",
                height: "auto",
                justifyContent:
                  showDetails == "immunization-records" ? "" : "space-between",
              }}
            >
              Immunization Records
              <span onClick={() => toggle("immunization-records")}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform:
                      showDetails == "immunization-records"
                        ? "rotate(180deg)"
                        : "",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
            {showDetails == "immunization-records" && (
              <div className="d-flex justify-content-center align-items-center">
                {immunizationSelectedRows.length ? (
                  <>
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                      }}
                    >
                      <img src={printerIcon} />
                    </button>
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        marginRight: "8px",
                      }}
                    >
                      <img src={downloadIcon} />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      disabled
                      style={{
                        backgroundColor: "white",
                        border: "none",
                      }}
                    >
                      <img src={printDisableIcon} />
                    </button>
                    <button
                      disabled
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        marginRight: "8px",
                      }}
                    >
                      <img src={downloadDisableIcon} />
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          {showDetails == "immunization-records" ? (
            <div className="table-card scroll-table position-relative rounded border-0  bg-white">
              <ReactStrapTable
                data={ImmunizationRowData}
                columns={ImmunizationColData}
                hasPagination={false}
                handleRowClick={() =>
                  setImmunizationDetails(!immunizationDetails)
                }
                enablerowRouting={true}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="heading-text"
              style={{
                width: "100vw",
                height: "auto",
                justifyContent:
                  showDetails == "lab-values" ? "" : "space-between",
              }}
            >
              Lab Values and Vital Signs
              <span onClick={() => toggle("lab-values")}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform:
                      showDetails == "lab-values" ? "rotate(180deg)" : "",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
            {showDetails == "lab-values" && (
              <div className="d-flex justify-content-center align-items-center">
                {labvaluesSelectedRows.length ? (
                  <>
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                      }}
                    >
                      <img src={printerIcon} />
                    </button>
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        marginRight: "8px",
                      }}
                    >
                      <img src={downloadIcon} />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      disabled
                      style={{
                        backgroundColor: "white",
                        border: "none",
                      }}
                    >
                      <img src={printDisableIcon} />
                    </button>
                    <button
                      disabled
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        marginRight: "8px",
                      }}
                    >
                      <img src={downloadDisableIcon} />
                    </button>
                  </>
                )}

                <span className="cursor-pointer">
                  <img src={addIcon} onClick={() => setShow(!show)} />
                </span>
              </div>
            )}
          </div>
          {showDetails == "lab-values" ? (
            <div className="table-card scroll-table position-relative rounded border-0  bg-white">
              <ReactStrapTable
                data={LabValuesRowData}
                columns={LabValuesColData}
                hasPagination={false}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={
            showDetails == "immunization-records" ? immunizationDetails : show
          }
          toggle={
            showDetails == "immunization-records"
              ? () => setImmunizationDetails(!immunizationDetails)
              : () => setShow(!show)
          }
        >
          <div className="casvas-header" style={{ paddingBottom: "5px" }}>
            <div>
              {(showDetails == "medical-condition" &&
                "Add Medical Conditions") ||
                (showDetails == "allergies" && "Add Allergies") ||
                (showDetails == "lab-values" &&
                  "Add Lab Values and Vital Signs") ||
                (showDetails == "immunization-records" &&
                  "Immunization Details")}{" "}
            </div>

            <div
              className="cursor-pointer"
              onClick={
                showDetails == "immunization-records"
                  ? () => setImmunizationDetails(!immunizationDetails)
                  : () => setShow(!show)
              }
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div
            className="section-devider-border"
            style={{
              margin: "0px 12px 24px 18px",
            }}
          ></div>
          <OffcanvasBody>
            {(showDetails == "medical-condition" && (
              <AddMedicalCondition
                medicalCondition={medicalCondition}
                setMedicalCondition={setMedicalCondition}
                diagnosedDate={diagnosedDate}
                setDiagnosedDate={setDiagnosedDate}
              />
            )) ||
              (showDetails == "allergies" && (
                <AddAllergies
                  addAllergy={addAllergy}
                  setAddAllergy={setAddAllergy}
                  reactionDate={reactionDate}
                  setReactiondate={setReactiondate}
                  reportedDate={reportedDate}
                  setReportedDate={setReportedDate}
                />
              )) ||
              (showDetails == "lab-values" && (
                <AddLabvalues
                  labValues={labValues}
                  setLabValues={setLabValues}
                />
              )) ||
              (showDetails == "immunization-records" && (
                <ImmunizationDetails />
              ))}
          </OffcanvasBody>
          {showDetails == "immunization-records" && (
            <div className="allergy-footer d-flex justify-content-end align-items-center">
              <Button
                onClick={() => setImmunizationDetails(!immunizationDetails)}
              >
                Back
              </Button>
              <Button color="primary">Refresh</Button>
            </div>
          )}
          {showDetails == "allergies" && (
            <>
              {addAllergy.allergyName == "" ||
              reactionDate == "" ||
              reportedDate == "" ||
              addAllergy.typeofReaction == "" ||
              addAllergy.notes == "" ? (
                <div className="allergy-footer">
                  <button disabled className="allergy-reset">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={refreshWhiteIcon} /> Reset
                    </div>
                  </button>
                  <Button
                    disabled
                    color="tranparent"
                    style={{ backgroundColor: "#D3D3D3", color: "#757575" }}
                    onClick={() => setShow(!show)}
                  >
                    <img src={saveDisableIcon} />
                    Save
                  </Button>
                </div>
              ) : (
                <div className="allergy-footer">
                  <Button color="primary" className="reset">
                    <img src={refreshPurpleIcon} /> Reset
                  </Button>
                  <Button color="primary" onClick={() => setShow(!show)}>
                    <img src={saveWhiteIcon} /> Save
                  </Button>
                </div>
              )}
            </>
          )}
          {showDetails == "medical-condition" && (
            <>
              {medicalCondition.diagnosed == "" ||
              medicalCondition.allergy == "" ||
              diagnosedDate == "" ||
              medicalCondition.conditions == "" ||
              medicalCondition.icd == "" ? (
                <div className="allergy-footer">
                  <button disabled className="allergy-reset">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={refreshWhiteIcon} /> Reset
                    </div>
                  </button>
                  <Button
                    disabled
                    color="tranparent"
                    style={{ backgroundColor: "#D3D3D3", color: "#757575" }}
                    onClick={() => setShow(!show)}
                  >
                    <img src={saveDisableIcon} />
                    Save
                  </Button>
                </div>
              ) : (
                <div className="allergy-footer">
                  <Button color="primary" className="reset">
                    <img src={refreshPurpleIcon} /> Reset
                  </Button>
                  <Button color="primary" onClick={() => setShow(!show)}>
                    <img src={saveWhiteIcon} /> Save
                  </Button>
                </div>
              )}
            </>
          )}
          {showDetails == "lab-values" && (
            <>
              {labValues.source == "" ||
              labValues.values == "" ||
              labValues.notes == "" ||
              labValues.description == "" ? (
                <div className="allergy-footer">
                  <button disabled className="allergy-reset">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                      <img src={refreshWhiteIcon} /> Reset
                    </div>
                  </button>
                  <Button
                    disabled
                    color="tranparent"
                    style={{ backgroundColor: "#D3D3D3", color: "#757575" }}
                  >
                    <img src={saveDisableIcon} />
                    Save
                  </Button>
                </div>
              ) : (
                <div className="allergy-footer">
                  <Button color="primary" className="reset">
                    <img src={refreshPurpleIcon} /> Reset
                  </Button>
                  <Button color="primary" onClick={() => setShow(!show)}>
                    <img src={saveWhiteIcon} /> Save
                  </Button>
                </div>
              )}
            </>
          )}
        </Offcanvas>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={editDetails}
          toggle={() => setEditDetails(!editDetails)}
        >
          <div className="casvas-header" style={{ paddingBottom: "5px" }}>
            <div>
              {(showDetails == "medical-condition" &&
                "Edit Medical Conditions") ||
                (showDetails == "allergies" && "Edit Allergies") ||
                (showDetails == "lab-values" &&
                  "Edit Lab Values and Vital Signs")}{" "}
            </div>

            <div
              className="cursor-pointer"
              onClick={() => setEditDetails(!editDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div
            className="section-devider-border"
            style={{
              margin: "0px 12px 24px 18px",
            }}
          ></div>
          <OffcanvasBody>
            {(showDetails == "medical-condition" && (
              <AddMedicalCondition
                medicalCondition={medicalCondition}
                setMedicalCondition={setMedicalCondition}
                diagnosedDate={diagnosedDate}
                setDiagnosedDate={setDiagnosedDate}
              />
            )) ||
              (showDetails == "allergies" && (
                <AddAllergies
                  addAllergy={addAllergy}
                  setAddAllergy={setAddAllergy}
                  reactionDate={reactionDate}
                  setReactiondate={setReactiondate}
                  reportedDate={reportedDate}
                  setReportedDate={setReportedDate}
                />
              )) ||
              (showDetails == "lab-values" && (
                <AddLabvalues
                  labValues={labValues}
                  setLabValues={setLabValues}
                />
              ))}
          </OffcanvasBody>
          <div className="allergy-footer">
            <Button color="primary" className="reset">
              <img src={refreshPurpleIcon} /> Reset
            </Button>
            <Button
              color="primary"
              onClick={() => setEditDetails(!editDetails)}
            >
              <img src={saveWhiteIcon} /> Save
            </Button>
          </div>
        </Offcanvas>
      </div>
    </div>
  );
};

export default Clinical;
